export default __webpack_public_path__ + "static/media/GreenRegular.07754a5c.png";